import styled from "styled-components"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`

const PageIntroContainer = styled.section`
  background-color: ${(props) => props.theme.d_color_gradients.d_dark};
`
const PageIntroTitle = styled.h1`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const PageFooterContainer = styled.div`
  color: ${(props) => props.theme.a_color_gradients.dark};
`
const PageTaxo = styled.span`
  background-color: ${(props) => props.theme.d_color_gradients.d_dark};
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export {
  AdditionalInfos,
  PageFooterContainer,
  PageIntroContainer,
  PageIntroTitle,
  PageTaxo,
}
